
<div v-if="showBadges" :class="['collection-card-badges', { small }]">
  <badge v-if="quantity > 1" icon="tag" :label="quantityLabel" />
  <badge v-if="card.sold" icon="attach_money" :label="soldLabel" />
  <badge
    @click.native="$emit('clickEstimation')"
    v-if="activeValueEstimation"
    :icon="typeIcon"
    :label="typeLabel"
    clickable
  />
</div>
